import React from 'react'
import { useNavigate } from 'react-router-dom'

import { Omnisearch } from '@fourthwall/module-ai-kit'

import { useCurrentShop } from '../../Dashboard/hooks/useCurrentShop'
import { useAIKitDashboard } from '../AIKitDashboardProvider'

/**
 * Wrapper component that integrates Omnisearch with React Router
 * Provides navigation callback to the Omnisearch module
 */
export const DashboardOmnisearch: React.FC = () => {
  const navigate = useNavigate()
  const { closeOmnisearch, openChatbot, isChatbotEnabled } = useAIKitDashboard()
  const { currentShop } = useCurrentShop()

  const handleNavigate = React.useCallback(
    (url: string) => {
      navigate(url)
      closeOmnisearch() // Close after navigation
    },
    [navigate, closeOmnisearch],
  )

  const handleOpenChatbot = React.useCallback(() => {
    closeOmnisearch() // Close Omnisearch
    openChatbot() // Open Chatbot
  }, [closeOmnisearch, openChatbot])

  // Don't render until we have shop ID
  if (!currentShop?.id) {
    return null
  }

  return (
    <Omnisearch
      onNavigate={handleNavigate}
      onClose={closeOmnisearch}
      onOpenChatbot={isChatbotEnabled ? handleOpenChatbot : undefined}
      shopId={currentShop.id}
    />
  )
}
